import { Model } from 'pinia-orm';
import Job from './Job';
import Location from './Location';
import shortid from 'shortid';

export default class VdabJob extends Model {

    static get entity () {
        return 'vdab_jobs';
    }

    /*constructor (record) {
        super(record);

        let studies = [];
        let languages = [];
        let driver_licences = [];
        let serv_competences = [];
        let servIds = [];

        console.log('competences', this.competences)

        for (let competence of this.competences) {
            switch (competence.type) {
                case 'Study Code':
                    //check if studies required
                    if (competence.id === 'A') {
                        this.study_required = false;
                    } else {
                        studies.push(Object.assign({uuid: shortid.generate()}, competence));
                    }
                    break;
                case 'Language':
                    languages.push(competence);
                    break;
                case 'Drivers License':
                    driver_licences.push(competence);
                    break;
                case 'SERV competence':
                    servIds.push(competence.id);
                    break;
            }
        }

        this.studies = studies;
        this.languages = languages;
        this.driver_licences = driver_licences;
        this.serv_ids = servIds;
    }*/

    static fields () {
        return {
            id: this.uid(),
            vdab_id: this.attr(null),
            reference: this.attr(null),
            job_id: this.attr(null),
            company_location_id: this.attr(null),
            category: this.attr(null),
            title: this.attr(null),
            locale: this.attr(null),
            competences: this.attr([]),
            serv_ids: this.attr([]),
            studies: this.attr([]),
            languages: this.attr([]),
            driver_licences: this.attr([]),
            description: this.attr(null),
            profile: this.attr(null),
            offer: this.attr(null),
            contract: this.attr(null),
            schedule: this.attr([]),
            experience: this.attr(0),
            jobsite_url: this.attr(null),
            vdab_url: this.attr(null),
            active: this.attr(false),
            status: this.attr(null),
            published: this.attr(null),
            start_date: this.attr(null),
            end_date: this.attr(null),
            contract_start_date: this.attr(null),
            contract_end_date: this.attr(null),
            study_required: this.attr(true),
            experience_is_enough: this.attr(false),
            number_to_fill: this.attr(null),
            published_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            full_service: this.attr(false),
            how_to_apply_comments: this.attr(null),

            //relationships
            job: this.belongsTo(Job, 'job_id'),
            location: this.belongsTo(Location, 'company_location_id'),
        }
    }

    static mergeCompetences
        (servs = null, studies = null, languages = null, drivers = null) {

        return [
            ...servs.map(competence => ({
                ...competence,
                type: 'SERV competence',
            })),
            ...studies.map(competence => ({
                ...competence,
                type: 'Study Code',
            })),
            ...languages.map(competence => ({
                ...competence,
                type: 'Language',
            })),
            ...drivers.map(competence => ({
                ...competence,
                type: 'Drivers License',
            })),
        ]
    }

    static noRequiredStudy () {
        return {
            id: "A",
            name: "Geen specifieke studievereisten",
            parent_path: null,
            path: "A",
            has_children: false
        };
    }
}
